import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SubsectionService } from './subsection.service';

export type RightPanelView = 'comment' | 'task';

interface PanelInitContext {
  pageId: string;
  entityType: string;
}

@Injectable({ providedIn: 'root' })
export class RightPanelCoordinatorService {
  private readonly subsectionService = inject(SubsectionService);
  private readonly initContextMap = new Map<RightPanelView, PanelInitContext>();

  readonly activePanel$: Observable<RightPanelView> = this.subsectionService.uiState$.pipe(
    map((state) => (state?.rightPanelView ?? 'comment') as RightPanelView),
    distinctUntilChanged()
  );

  getActivePanel(): RightPanelView {
    return (this.subsectionService.uiState?.rightPanelView ?? 'comment') as RightPanelView;
  }

  isActive(panel: RightPanelView): boolean {
    return this.getActivePanel() === panel;
  }

  needsReinitialization(panel: RightPanelView, pageId: string, entityType: string): boolean {
    const lastContext = this.initContextMap.get(panel);
    if (!lastContext) return true;
    return lastContext.pageId !== pageId || lastContext.entityType !== entityType;
  }

  markInitialized(panel: RightPanelView, pageId: string, entityType: string): void {
    this.initContextMap.set(panel, { pageId, entityType });
  }
}
